e4.productListWithFacets = {
    debug: false,
    jProductList: jQuery( '.js-e-productlist-v2' ),
    init: function () {
        if ( e4.productListWithFacets.jProductList.length === 1 ) {
            e4.productListWithFacets.event = sika.utillities.registerEvents( 'build builded itemAppended skeletonReplaced', 'productListWithFacets' );
            e4.productListWithFacets.bindEvents();
            var objContext = e4.productListWithFacets.context.get();
            e4.productListWithFacets.products.init( objContext );
            e4.productListWithFacets.facets.init( objContext );
            e4.productListWithFacets.context.set( objContext );
        }
    },
    bindEvents: function () {
        jQuery( window ).on( 'beforeunload', e4.productListWithFacets.context.clear );
        e4.productListWithFacets.jProductList.on( 'click', '.js-e-products-item', function ( event ) {
            e4.productListWithFacets.products.navigateToProductPage( event.target );
        } );
        e4.productListWithFacets.jProductList.on( 'submit', '.js-e-product-form', function ( event ) {
            event.preventDefault();
            e4.productListWithFacets.products.addToCart( event.target );
        } );
        e4.productListWithFacets.jProductList.on( 'click', '.js-e-productlist-load-more-products-btn', function ( event ) {
            event.preventDefault();
            e4.productListWithFacets.products.loadNextPage();
        } );
        e4.productListWithFacets.jProductList.on( 'submit', '.js-e-productlist-form', function ( event ) {
            event.preventDefault();
            e4.productListWithFacets.apply( event.target );
        } );
        e4.productListWithFacets.jProductList.on( 'change', '.js-e-productlist-sort', function ( event ) {
            e4.productListWithFacets.setSort( event.target );
            e4.productListWithFacets.loadProductsAndFacets();
        } );
        e4.productListWithFacets.jProductList.on( 'click', '.js-e-select-multiple-apply-btn', function ( event ) {
            e4.productListWithFacets.facets.apply( event.target );
        } );
        e4.productListWithFacets.jProductList.on( 'keydown keypress', '.js-e-productlist-facet-option-input[type="text"]', function ( event ) {
            if ( event.keyCode === 13 ) {
                event.preventDefault();
                e4.productListWithFacets.facets.apply( event.target );
            }
        } );
        e4.productListWithFacets.jProductList.on( 'click', '.js-e-productlist-clear-selected-facet-option-btn', function ( event ) {
            event.preventDefault();
            e4.productListWithFacets.facets.clearSelectedFacetOption( event.currentTarget );
        } );
        e4.productListWithFacets.jProductList.on( 'click', '.js-e-productlist-clear-all-selected-facet-options-btn', function ( event ) {
            event.preventDefault();
            e4.productListWithFacets.facets.clearAllSelectedFacetOptions();
        } );
        e4.productListWithFacets.jProductList.on( 'mouseenter', '.js-e-products-item-image[data-image-hover]', function ( event ) {
            var jImage      = jQuery( event.target ),
                strHoverSrc = jImage.data( 'image-hover' );
            jImage.attr( 'data-image-base', event.target.src ).attr( 'src', strHoverSrc );
        } ).on( 'mouseleave', '.js-e-products-item-image[data-image-hover]', function ( event ) {
            var jImage     = jQuery( event.target ),
                strBaseSrc = jImage.data( 'image-base' );
            jImage.attr( 'src', strBaseSrc );
        } );
        e4.productListWithFacets.popper.init();
    },
    ajax: function ( objAjaxSettings ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            method: 'GET',
            dataType: 'json',
            url: e4.productListWithFacets.getFeedUrl(),
            cache: false,
            data: e4.productListWithFacets.getParamsFromForm()
        }, objAjaxSettings ) );
        jqXHR.fail( function ( jqXHR, textStatus, errorThrown ) {
            e4.productListWithFacets.jProductList.find( '.js-e-productlist-products' ).html( '<h4>' + errorThrown + '</h4>' );
        } );
        jqXHR.always( function () {
            e4.loading.resolveWait( '.js-e-productlist-with-facets' );
            e4.productListWithFacets.jProductList.find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
        } );
        return jqXHR;
    },
    popper: {
        init: function () {
            e4.productListWithFacets.popper.bindEvents();
        },
        bindEvents: function () {
            e4.productListWithFacets.jProductList.on( 'click', '.js-e-productlist-filters-items-trigger', function ( event ) {
                e4.productListWithFacets.popper.trigger( event.currentTarget );
            } ).on( 'click', function ( event ) {
                e4.productListWithFacets.popper.toggle( event.target );
            } );
        },
        trigger: function ( domElm ) {
            var reference                      = jQuery( domElm ),
                popper                         = reference.next( '.js-e-productlist-filters-items-content' ),
                referenceParentSublingsTrigger = reference.parent( '.js-e-productlist-filters-items' ).siblings().find( '.js-e-productlist-filters-items-trigger' );
            var popit                          = new Popper( reference, popper, {
                placement: 'bottom-end',
                modifiers: {
                    flip: {
                        behavior: [
                            'left',
                            'right'
                        ]
                    }
                }
            } );
            referenceParentSublingsTrigger.removeClass( 'open' );
            referenceParentSublingsTrigger.next( '.js-e-productlist-filters-items-content' ).addClass( 'closed' );
            reference.toggleClass( 'open' );
            reference.next( '.js-e-productlist-filters-items-content' ).toggleClass( 'closed' );
        },
        toggle: function ( domElm ) {
            var isTriggerElement   = jQuery( domElm ).is( '.js-e-productlist-filters-items-trigger' ),
                hasTriggerChildren = jQuery( domElm ).parents( '.js-e-productlist-filters-items-trigger' ).length > 0,
                isTargetElement    = jQuery( domElm ).is( '.js-e-productlist-filters-items-content' ),
                hasTargetChildren  = jQuery( domElm ).parents( '.js-e-productlist-filters-items-content' ).length > 0;
            if ( isTriggerElement === false && hasTriggerChildren === false && isTargetElement === false && hasTargetChildren === false ) {
                jQuery( '.js-e-productlist-filters-items-trigger' ).removeClass( 'open' );
                jQuery( '.js-e-productlist-filters-items-content' ).addClass( 'closed' );
            }
        }
    },
    loadProductsAndFacets: function () {
        e4.productListWithFacets.setPageNumber( 1 );
        e4.productListWithFacets.context.set( { currentPageNumber: 1 } );
        return e4.productListWithFacets.ajax( {
            beforeSend: function () {
                e4.productListWithFacets.jProductList.find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            }
        } ).done( function ( jsonData ) {
            e4.productListWithFacets.jProductList.trigger( e4.productListWithFacets.event.build );
            e4.productListWithFacets.context.set( jsonData.list );
            var objContext = e4.productListWithFacets.context.get();
            e4.productListWithFacets.products.build( jsonData );
            e4.productListWithFacets.products.init( objContext );
            e4.productListWithFacets.facets.build( jsonData );
            e4.productListWithFacets.facets.init( objContext );
            e4.productListWithFacets.jProductList.trigger( e4.productListWithFacets.event.builded, jsonData );
        } );
    },
    getFeedUrl: function ( boolIncludeFacets ) {
        // Get custom feed url if any, to support alternative feeds.
        var strReturnValue = e4.settings.ecom.productListWithFacets.feedUrl,
            strCustomUrl   = e4.productListWithFacets.jProductList.data( 'feed-url' );
        if ( sika.utillities.looksLikeUrl( strCustomUrl ) === true ) {
            strReturnValue = strCustomUrl;
        }
        if ( boolIncludeFacets !== false ) {
            strReturnValue += ( strReturnValue.includes( '?' ) === true ? '&' : '?' ) + 'includeFacets=true';
        }
        return strReturnValue;
    },
    getParamsFromForm: function () {
        return e4.productListWithFacets.jProductList.find( '.js-e-productlist-form' ).serialize();
    },
    showLoadMoreButton: function () {
        jQuery( '.js-e-productlist-load-more-products-btn' ).removeClass( 'd-none' );
    },
    hideLoadMoreButton: function () {
        jQuery( '.js-e-productlist-load-more-products-btn' ).addClass( 'd-none' );
    },
    observeIntersectionOnLastItemOrShowLoadMoreButton: function ( objContext ) {
        var hasMorePages                        = objContext.pageCount > objContext.currentPageNumber,
            isShowLoadMoreButtonIntervalReached = objContext.currentPageNumber % e4.settings.ecom.productListWithFacets.lazyLoad.buttonShowInterval === 0,
            isNextPageFullPageSize              = hasMorePages === true && objContext.productCount - ( objContext.pageSize * objContext.currentPageNumber ) > objContext.pageSize,
            isLoadMoreButtonDisabled            = objContext.productCount < e4.settings.ecom.productListWithFacets.lazyLoad.autoLoadCount;
        if ( isShowLoadMoreButtonIntervalReached === true && isNextPageFullPageSize === true && isLoadMoreButtonDisabled === false ) {
            e4.productListWithFacets.showLoadMoreButton();
        }
        else {
            e4.productListWithFacets.hideLoadMoreButton();
            if ( hasMorePages === true ) {
                e4.productListWithFacets.products.observeIntersectionOnLastItem();
            }
        }
    },
    setPageNumber: function ( intPageNumber ) {
        e4.productListWithFacets.jProductList.find( 'input[name="PageNum"]' ).val( intPageNumber );
    },
    getPageNumberByProductItemNode: function ( domNode ) {
        var intPageSize         = e4.productListWithFacets.context.get().pageSize,
            intProductItemIndex = ( jQuery( domNode ).closest( '.js-sika-productlist-item' ).index() + 1 ),
            intPageNumber       = Math.ceil( intProductItemIndex / intPageSize );
        return intPageNumber;
    },
    setSort: function ( domNode ) {
        var splitValue = domNode.value.split( ' ' );
        e4.productListWithFacets.jProductList.find( 'input[name="SortBy"]' ).val( splitValue[ 0 ] );
        e4.productListWithFacets.jProductList.find( 'input[name="SortOrder"]' ).val( splitValue[ 1 ] );
    },
    setScrollTop: function ( intScrollTop ) {
        jQuery( 'html,body' ).scrollTop( intScrollTop );
    },
    getScrollTop: function () {
        return Math.floor( jQuery( window ).scrollTop() );
    },
    products: {
        init: function ( objContext ) {
            if ( objContext.productCount > 0 ) {
                e4.productListWithFacets.products.hideAlert();
                if ( sika.utillities.observer.isSupported === true ) {
                    e4.productListWithFacets.products.setSkeletonItemHeight();
                    e4.productListWithFacets.products.observeIntersectionOnSkeleton();
                    if ( objContext.scrollTop !== null ) {
                        e4.productListWithFacets.setScrollTop( objContext.scrollTop );
                    }
                    e4.productListWithFacets.observeIntersectionOnLastItemOrShowLoadMoreButton( objContext );
                }
                else {
                    sika.utillities.debug( [
                        'IntersectionObserver not available',
                        'switching to pagination'
                    ], e4.productListWithFacets.debug );
                    jQuery( '.js-e-productlist-pagination' ).prop( 'hidden', false );
                    e4.productListWithFacets.jProductList.addClass( 'has-pagination' );
                }
            }
            else {
                e4.productListWithFacets.products.showAlert();
            }
        },
        build: function ( jsonData ) {
            if ( jsonData.products !== null ) {
                var jProducts = e4.productListWithFacets.jProductList.find( '.js-e-productlist-products' );
                jQuery( '.js-e-productlist-products-count' ).html( jsonData.list.productCount );
                e4.productListWithFacets.products.setViewingText( jsonData );
                var strItemClasses  = jProducts.data( 'item-classes' ),
                    arrProductsHtml = jsonData.products.map( function ( p ) {
                        return e4.productListWithFacets.products.getListItemHtmlWithItemClasses( p.listItemHtml, strItemClasses )
                    } );
                jProducts.html( arrProductsHtml.join( '' ) );
            }
        },
        setViewingText: function ( json ) {
            var jElement        = jQuery( '.js-sika-productlist-show-count' ),
                strText         = jElement.data( 'textReplace' ),
                strTextReplaced = strText.replace( 'viewingFrom', json.list.viewingFrom ).replace( 'viewingTo', json.list.viewingTo ).replace( 'productCount', json.list.productCount );
            jElement.text( strTextReplaced );
        },
        getListItemHtmlWithItemClasses: function ( strListItemHtml, strItemClasses ) {
            return strListItemHtml;
        },
        showAlert: function () {
            e4.productListWithFacets.jProductList.find( '.js-e-productlist-products-alert' ).removeClass( 'd-none' );
        },
        hideAlert: function () {
            e4.productListWithFacets.jProductList.find( '.js-e-productlist-products-alert' ).addClass( 'd-none' );
        },
        loadProductsByPageNumber: function ( intPageNumber, fnCallback ) {
            e4.productListWithFacets.setPageNumber( intPageNumber );
            e4.productListWithFacets.ajax( {
                url: e4.productListWithFacets.getFeedUrl( false )
            } ).done( function ( jsonData ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( jsonData );
                }
            } );
        },
        observeIntersectionOnLastItem: function () {
            var arrDomObservables = e4.productListWithFacets.jProductList.find( '.js-e-productlist-products' ).find( '.js-sika-productlist-item' ).last().toArray();
            sika.utillities.observer.bind( arrDomObservables, e4.productListWithFacets.products.loadNextPageOnLastItemIntersection, e4.settings.ecom.productListWithFacets.lazyLoad.observerOptions );
        },
        loadNextPageOnLastItemIntersection: function ( objEntry, objObserver ) {
            if ( objEntry.isIntersecting === true ) {
                e4.productListWithFacets.products.loadNextPage();
                objObserver.unobserve( objEntry.target );
            }
        },
        loadNextPage: function () {
            // Manually load next batch on click load-more btn or if last server-loaded product item is in viewport
            var domLastItem       = e4.productListWithFacets.jProductList.find( '.js-e-productlist-products' ).find( '.js-sika-productlist-item' ).get( -1 ),
                intNextPageNumber = e4.productListWithFacets.getPageNumberByProductItemNode( domLastItem ) + 1;
            e4.productListWithFacets.context.set( {
                currentPageNumber: intNextPageNumber
            } );
            e4.productListWithFacets.products.loadProductsByPageNumber( intNextPageNumber, function ( jsonData ) {
                e4.productListWithFacets.products.appendItems( jsonData );
                e4.productListWithFacets.observeIntersectionOnLastItemOrShowLoadMoreButton( e4.productListWithFacets.context.get() );
                e4.productListWithFacets.products.setViewingText( jsonData );
            } );
        },
        appendItems: function ( jsonData ) {
            var strItemClasses = e4.productListWithFacets.jProductList.find( '.js-e-productlist-products' ).data( 'item-classes' );
            jQuery.each( jsonData.products, function ( intIndex, objProduct ) {
                e4.productListWithFacets.jProductList.find( '.js-e-productlist-products' ).append( e4.productListWithFacets.products.getListItemHtmlWithItemClasses( objProduct.listItemHtml, strItemClasses ) );
                e4.productListWithFacets.jProductList.trigger( e4.productListWithFacets.event.itemAppended, objProduct );
            } );
            if ( sessionStorage.getItem( 'sika.pdfgen.active' ) === 'true' || sessionStorage.getItem( 'sika.pdfgen.logoActive' ) === 'true' ) {
                jQuery( '.js-e-productlist-v2' ).find( '.js-sika-productsheet-list-add-wrap' ).show();
            }
        },
        getSkeletonItem: function ( intPageNumber, intIndex ) {
            return e4.productListWithFacets.jProductList.find( '.js-e-productlist-products' ).find( '.js-e-productlist-skeleton-item[data-page="' + intPageNumber + '"][data-index="' + intIndex + '"]' );
        },
        setSkeletonItemHeight: function () {
            // Get and set the height of the skeleton items.
            var intFirstItemHeight = e4.productListWithFacets.jProductList.find( '.js-e-productlist-products' ).find( '.js-sika-productlist-item' ).first().outerHeight();
            jQuery( '.js-e-productlist-skeleton-item' ).css( { height: intFirstItemHeight } );
        },
        observeIntersectionOnSkeleton: function () {
            var arrObservableSkeletons = jQuery( '.js-e-productlist-skeleton-item' ).filter( '.is-observable' ).toArray();
            if ( arrObservableSkeletons.length > 0 ) {
                sika.utillities.observer.bind( arrObservableSkeletons, e4.productListWithFacets.products.loadPageOnSkeletonIntersection, e4.settings.ecom.productListWithFacets.lazyLoad.observerOptions );
            }
        },
        loadPageOnSkeletonIntersection: function ( objEntry, objObserver ) {
            if ( objEntry.isIntersecting === true ) {
                var jEntryTarget  = jQuery( objEntry.target ),
                    intPageNumber = parseInt( jEntryTarget.data( 'page' ) );
                objObserver.unobserve( objEntry.target );
                e4.productListWithFacets.products.loadProductsByPageNumber( intPageNumber, e4.productListWithFacets.products.replaceSkeletonItems );
            }
        },
        replaceSkeletonItems: function ( jsonData ) {
            var strItemClasses = e4.productListWithFacets.jProductList.find( '.js-e-productlist-products' ).data( 'item-classes' );
            // replace each matching skeleton item (by pagenum and index) with matching product in fetched json
            jQuery.each( jsonData.products, function ( intIndex, objProduct ) {
                var intPageNum    = jsonData.list.currentPageNumber,
                    jSkeletonItem = e4.productListWithFacets.products.getSkeletonItem( intPageNum, intIndex );
                if ( jSkeletonItem !== undefined ) {
                    jSkeletonItem.parent().replaceWith( e4.productListWithFacets.products.getListItemHtmlWithItemClasses( objProduct.listItemHtml, strItemClasses ) );
                    e4.productListWithFacets.jProductList.trigger( e4.productListWithFacets.event.skeletonReplaced, objProduct );
                }
            } );
        },
        navigateToProductPage: function ( domNode ) {
            jQuery( window ).off( 'beforeunload', e4.productListWithFacets.context.clear );
            var strProductPageUrl = null,
                jTriggerNode      = jQuery( domNode );
            jQuery.when( e4.productListWithFacets.getPageNumberByProductItemNode( domNode ) ).then( function ( intPageNumber ) {
                if ( jTriggerNode.closest( 'a[href]' ).length === 1 ) {
                    strProductPageUrl = jTriggerNode.closest( 'a[href]' ).attr( 'href' );
                }
                else if ( jTriggerNode.closest( 'form, .dropdown' ).length === 0 && window.getSelection().toString() === '' ) {
                    strProductPageUrl = jTriggerNode.closest( '.js-e-products-item' ).find( 'a[href]' ).not( 'a[href="#"]' ).first().attr( 'href' );
                }
                if ( strProductPageUrl !== null ) {
                    e4.productListWithFacets.context.set( {
                        currentPageNumber: intPageNumber
                    }, true );
                    location.href = strProductPageUrl;
                }
            } );
        },
        addToCart: function ( domForm ) {
            sika.utillities.disableAllSubmitButtonsInForm( domForm );
            e4.require.js( e4.settings.require.jQueryValidate, function () {
                var jForm        = jQuery( domForm ),
                    objValidator = jForm.validate( {
                        submitHandler: function () {
                            e4.product.addToCart( domForm ).done( function () {
                                sika.utillities.enableAllSubmitButtonsInForm( domForm );
                            } );
                        }
                    } );
                if ( jForm.valid() === true ) {
                    objValidator.settings.submitHandler.call( objValidator, objValidator.currentForm );
                }
                else {
                    sika.utillities.enableAllSubmitButtonsInForm( domForm );
                }
            } );
        }
    },
    facets: {
        init: function () {
        },
        build: function ( jsonData ) {
            if ( jsonData.facets !== null ) {
                jQuery( '.js-e-productlist-facets' ).html( jsonData.facets.html );
                jQuery( '.js-e-productlist-selected-facet-options-count' ).html( jsonData.facets.selectedFacetOptionsCount === 0 ? '' : jsonData.facets.selectedFacetOptionsCount );
                e4.productListWithFacets.products.setViewingText( jsonData );
            }
        },
        apply: function () {
            e4.productListWithFacets.loadProductsAndFacets();
        },
        clearSelectedFacetOption: function ( domNode ) {
            var jNode                     = jQuery( domNode ),
                strFacetParameterName     = jNode.data( 'facet-parameter-name' ),
                strFacetOptionValue       = jNode.data( 'facet-option-value' ),
                jSelectedFacetOptionInput = e4.productListWithFacets.jProductList.find( '.js-e-productlist-facet-option-input[name="' + strFacetParameterName + '"][value="' + strFacetOptionValue + '"]' );
            if ( jSelectedFacetOptionInput.attr( 'type' ) === 'text' ) {
                jSelectedFacetOptionInput.val( '' );
            }
            else {
                jSelectedFacetOptionInput.prop( 'checked', false );
            }
            e4.productListWithFacets.facets.apply();
        },
        clearAllSelectedFacetOptions: function () {
            var jSelectedFacetOptionInputs = e4.productListWithFacets.jProductList.find( '.js-e-productlist-facet-option-input' );
            jSelectedFacetOptionInputs.filter( '[type="checkbox"]' ).prop( 'checked', false );
            jSelectedFacetOptionInputs.filter( '[type="text"]' ).val( '' );
            e4.productListWithFacets.facets.apply();
        }
    },
    context: {
        get: function () {
            var returnValue = jQuery.extend( {}, {
                currentPageNumber: 1,
                pageSize: null,
                pageCount: null,
                productCount: null,
                scrollTop: 0
            }, history.state || e4.productListWithFacets.jProductList.data() );
            return returnValue;
        },
        set: function ( objContext, boolIsNavigatingToProductPage ) {
            var objContextNew = jQuery.extend( {}, e4.productListWithFacets.context.get(), objContext );
            if ( objContext.scrollTop === undefined ) {
                objContextNew.scrollTop = e4.productListWithFacets.getScrollTop();
            }
            history.replaceState( objContextNew, null, e4.productListWithFacets.context.getBrowserUrl( objContextNew, boolIsNavigatingToProductPage ) );
            history.scrollRestoration = 'manual';
        },
        clear: function () {
            history.replaceState( null, null, null );
            history.scrollRestoration = 'manual';
        }, /* jshint ignore:start */
        getBrowserUrl: function ( objContext, boolIsNavigatingToProductPage ) {
            var strReturnValue                = location.pathname,
                arrParams                     = e4.productListWithFacets.getParamsFromForm().split( '&' ),
                arrParamsToShowInUrl          = [],
                arrParamNamesToExcludeFromUrl = [
                    'pagenum',
                    'fg',
                    'pagesize',
                    'q='
                ];
            if ( e4.settings.ecom.productListWithFacets.showParamsInUrl === true ) {
                if ( e4.productListWithFacets.jProductList.data( 'is-using-ecommerce-navigation' ) === true ) {
                    arrParamNamesToExcludeFromUrl.push( 'groupid' );
                }
                if ( e4.productListWithFacets.jProductList.find( '.js-e-productlist-sort' ).data( 'is-default' ) === true && location.search.toLowerCase().includes( 'sortby=' ) === false ) {
                    arrParamNamesToExcludeFromUrl.push( 'sortby', 'sortorder' );
                }
                for ( var i = 0; i < arrParams.length; i++ ) {
                    var strParamName = arrParams[ i ].split( '=' )[ 0 ].toLowerCase();
                    if ( strParamName !== '' && arrParamNamesToExcludeFromUrl.includes( strParamName ) === false && arrParamNamesToExcludeFromUrl.includes( arrParams[ i ].toLowerCase() ) === false ) {
                        arrParamsToShowInUrl.push( arrParams[ i ] );
                    }
                }
                if ( boolIsNavigatingToProductPage === true && objContext.currentPageNumber > 1 ) {
                    arrParamsToShowInUrl.push( 'PageNum=' + objContext.currentPageNumber );
                }
                if ( arrParamsToShowInUrl.length > 0 ) {
                    strReturnValue += '?' + arrParamsToShowInUrl.join( '&' );
                }
            }
            return strReturnValue;
        } /* jshint ignore:end */
    }
};
